(function ($) {
	const megamenuSubcategoryMarginDiff = 40;
	var megamenuIndex = 0;
	var headerCoords = $(".header__topbar").length ? $(".header__topbar")[0].getBoundingClientRect() : false;

	function resetScrollPosition(scrollTopYPosition) {
		if (window.innerWidth <= 768) {
			$("#Megamenu").scrollTop(scrollTopYPosition);
		}
	}

	$(document).ready(function () {
		$(".has-megamenu").on("click mouseenter", function (e) {
			if($("#Megamenu").hasClass("show") && e.type !== "mouseenter"){
				$("#Megamenu").removeClass("show");
				$("header").removeClass("megamenu-active");
				$(".megamenu-overlay").removeClass("show");
				return;
			}
			$("#Megamenu").addClass("show");
			$("header").addClass("megamenu-active");
			$(".megamenu-overlay").addClass("show");
		});

		$(".has-megamenu").on("mouseleave", function (e) {
			if($(e.relatedTarget).closest("#Megamenu").length == 0){
				$("#Megamenu").removeClass("show");
				$("header").removeClass("megamenu-active");
				$(".megamenu-overlay").removeClass("show");
			}
		});

		$("#Megamenu").on("mouseleave", function (e) {
			if($(e.relatedTarget).closest(".has-megamenu").length == 0 && $(window).width() >= 768){
				$(this).removeClass("show");
				$("header").removeClass("megamenu-active");
				$(".megamenu-overlay").removeClass("show");
			}
		})

		$(".megamenu-overlay").on("click mouseenter", function () {
			$("header").removeClass("megamenu-active");
			$("#Megamenu").removeClass("show");
			$(this).removeClass("show");
		});

		$(".megamenu-toggler").on("click", function () {
			$("#Megamenu").toggleClass("show");
			$("body, html").toggleClass("no-scroll");
		});

		$(".megamenu-category-more, .submenu-toggle").on("click", function (e) {
			e.preventDefault();
			let oldScrollTop = $("#Megamenu").scrollTop();
			const category = $(this).closest(".megamenu-category").find(".megamenu-category-name").data("category");

			$(".subcategory-group").hide();
			$(`.subcategory-group[data-category="${category}"]`).show();
			$(".mobile-header .megamenu-mobile-back").data("oldScrollTop", oldScrollTop);
			$(".mobile-header .megamenu-mobile-back").data("subcategory-group", $(this).closest(".subcategory-group").data("category"));
			resetScrollPosition(0);
		});

		$(".megamenu-category-more, .submenu-toggle").on("click", function () {
			let $currentList = $(this).closest(".indexed");
			let currentIndex = $(this).closest(".indexed").index();
			megamenuIndex = currentIndex;

			$(".indexed").eq(currentIndex).addClass("show");
			$currentList.addClass("move-left");

			if(megamenuIndex <= 0){
				$(".mobile-header .megamenu-mobile-back").hide();
				$(".mobile-header .megamenu-toggler").show();
			}else{
				$(".mobile-header .megamenu-mobile-back").show();
				$(".mobile-header .megamenu-toggler").hide();
			}
		});

		$(".megamenu-back").on("click", function () {
			let $currentList = $(this).closest(".indexed");
			let currentIndex = $(this).closest(".indexed").index();
			let subcategoryGroupToShow = $(".mobile-header .megamenu-mobile-back").data("subcategory-group");

			$currentList.removeClass("show");
			$(".indexed").eq(currentIndex-2).removeClass("move-left");
			$(`.subcategory-group[data-category="${subcategoryGroupToShow}"]`).show();
		});

		$(".mobile-header .megamenu-mobile-back").on("click", function (){
			let $currentList = $(".indexed").eq(megamenuIndex);
			let currentIndex = $currentList.index();
			let subcategoryGroupToShow = $(".mobile-header .megamenu-mobile-back").data("subcategory-group");

			$currentList.removeClass("show");
			$(".indexed").eq(currentIndex - 2).removeClass("move-left");
			$(`.subcategory-group[data-category="${subcategoryGroupToShow}"]`).show();
			megamenuIndex--;

			if(megamenuIndex <= 0){
				$(this).hide();
				$(".mobile-header .megamenu-toggler").show();
			}
		});

		$(".megamenu-category-more, .submenu-toggle").on("click", function () {
			let categoryName = $(this).closest(".megamenu-category").find(".megamenu-category-name").data("category");
			let subcategoryElement = $('.subcategory-group[data-category="' + categoryName + '"]')[0];

			if (
				$(window).width() >= 768 &&
				$(subcategoryElement).height() > $("#Megamenu").height()
			) {
				$("#Megamenu").height(
					$(subcategoryElement).height() + megamenuSubcategoryMarginDiff
				);
			}
		});
		
		$(".megamenu-back").on("click", () => {
			$("#Megamenu").height("");
		});

		//Todo: el oldScrollposition debe guardarse para cada stage del megamenu..antes al ser 1 solo estado funcionaba bien pero ahora debe guardar 2
		$(".megamenu-mobile-back").on("click", function () {
			//resetScrollPosition( $(this).data("oldScrollTop") ?? 0 );
		});

		$('.contacto-button, .mobileContactBtn').on("click", function(e) {
			e.preventDefault();
			Beacon("open");
	   	});

		$(window).on("resize", () => {
			if (
				$(window).width() >= 768 &&
				$('.subcategories.show .subcategory-group[style=""]').length > 0 &&
				$('.subcategories.show .subcategory-group[style=""]').height() >
					$("#Megamenu").height()
			) {
				$("#Megamenu").height(
					$('.subcategories.show .subcategory-group[style=""]').height() +
						megamenuSubcategoryMarginDiff
				);
			}
		});

		$(window).scroll(function () {
			if($(".header__mainMenu").length > 0 && $(window).width() > 767){
				if ($(this).scrollTop() >= $(".header__topbar").height()) {
					if($(".headerEmptySpace").length == 0){
						$("header").append('<div class="headerEmptySpace"></div>');
						$(".headerEmptySpace").height( $(".header__mainMenu").height() );
					}
					$(".header__mainMenu").addClass("scrolled");
					$("#Megamenu").addClass("scrolled");
					
				} else {
					$(".header__mainMenu").removeClass("scrolled");
					$("#Megamenu").removeClass("scrolled");
					$(".headerEmptySpace").remove();
				}
			}

			if($(".header__topbar").length > 0 && $(".woocommerce-checkout").length == 0 && $(window).width() <= 767){
				if($(this).scrollTop() >= headerCoords.top){
					if($(".headerEmptySpace").length == 0){
						$("header").append('<div class="headerEmptySpace"></div>');
						$(".headerEmptySpace").height( $(".header__topbar").height() );
					}
					$(".header__topbar").addClass("scrolled");
				}else{
					$(".header__topbar").removeClass("scrolled");
					$(".headerEmptySpace").remove();
				}
			}else{
				$(".header__topbar").removeClass("scrolled");
			}
		});
	});
})(jQuery);
